import { render, staticRenderFns } from "./LeaveBalance.vue?vue&type=template&id=cf34f458&scoped=true"
import script from "./LeaveBalance.vue?vue&type=script&lang=js"
export * from "./LeaveBalance.vue?vue&type=script&lang=js"
import style0 from "./LeaveBalance.vue?vue&type=style&index=0&id=cf34f458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf34f458",
  null
  
)

export default component.exports